'use client';

import { styled } from '@linaria/react';
import { useDateContext } from '@fe-news/hooks/use-date-context';
import Image from 'next/image';
import { formatTime } from '@fe-common-utils/libs/time';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Time = styled.div`
  font-size: 20px;
  color: #515c69;
  line-height: 1.2;
  letter-spacing: 0.5px;
  font-weight: 600;
`;

const DateContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #848d97;
  line-height: 20px;
  position: relative;

  img {
    margin-right: 8px;
  }
`;

const DefaultDate = styled.div`
  color: #848d97;
  width: 150px;
  caret-color: transparent;
  white-space: nowrap;
`;

const MILLISECONDS = 1000;

const PopTopicTimelineFilter = () => {
  const { dates } = useDateContext();

  const searchYear = new Date(dates[1]).getFullYear();
  const displayYear = searchYear === new Date().getFullYear() ? `${searchYear}至今` : searchYear;

  const start = formatTime(dates[0]?.getTime() / MILLISECONDS, 'YYYYMMDD', '/');
  const end = formatTime(dates[1]?.getTime() / MILLISECONDS, 'YYYYMMDD', '/');

  return (
    <Container>
      <Time>{displayYear}</Time>
      <DateContainer>
        <Image src='/assets/icons/date/calendar.svg' width={16} height={16} alt='calendar-icon' unoptimized />
        <DefaultDate>{`${start} - ${end}`}</DefaultDate>
      </DateContainer>
    </Container>
  );
};

export default PopTopicTimelineFilter;
